module.exports = __webpack_public_path__ + "static/img/tunnel-text-2.a214774d.png";